import React from "react";
import "./supportGroupFooter.scss";
//import { navigate } from "gatsby";
//import Button from "../../atoms/button/button";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
//import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

interface SupportGroupFooterInterface {
  data?: any;
}

const settings = {
  dots: true,
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1.1,
  slidesToScroll: 1,
  rows: 2,
  slidesPerRow: 1,
  initialSlide: 0,
};

const SupportGroupFooter = (props: SupportGroupFooterInterface) => {
  const { data } = props;
  return (
    <div className="m-sup-footer">
      <div className="m-sup-footer__container">
        <div className="m-sup-footer__container__title">
          <h3>
            {
              data?.referenciaContenido[0]?.referenciaPlantillaContenido[4]
                .tipoTitulo
            }
          </h3>
        </div>
        <div className="m-sup-footer__container__cards hide-on-mobile">
          {data?.referenciaContenido[0]?.referenciaPlantillaContenido?.map(
            (elem, idx) => {
              return idx !=
                data?.referenciaContenido[0]?.referenciaPlantillaContenido
                  ?.length -
                  1 ? (
                <div
                  className="m-sup-footer__container__cards__c"
                  key={"key " + idx}
                >
                  <img
                    src={elem?.imagenPrincipal[0]?.file?.url}
                    alt={elem?.imagenPrincipal[0]?.title}
                  />
                  <p>{elem?.tituloBanner}</p>
                </div>
              ) : null;
            }
          )}
        </div>
        <div className="show-on-mobile-group">
          <Slider {...settings}>
            {data?.referenciaContenido[0]?.referenciaPlantillaContenido?.map(
              (elem, idx) => {
                return idx !=
                  data?.referenciaContenido[0]?.referenciaPlantillaContenido
                    ?.length -
                    1 ? (
                  <div>
                    key={"key " + idx}
                    <div className="m-sup-footer__container__cards__c">
                      <img
                        src={elem?.imagenPrincipal[0]?.file?.url}
                        alt={elem?.imagenPrincipal[0]?.title}
                      />
                      <p>{elem?.tituloBanner}</p>
                    </div>
                  </div>
                ) : null;
              }
            )}
          </Slider>
        </div>
      </div>
      <div className="m-sup-footer__phrase">
        <div className="m-sup-footer__phrase__container">
          <div className="m-sup-footer__phrase__container__title">
            <div className="blockquoteopen"></div>
            <h3>
              {
                JSON.parse(
                  data?.referenciaContenido[0]?.referenciaPlantillaContenido[
                    data?.referenciaContenido[0]?.referenciaPlantillaContenido
                      ?.length - 1
                  ]?.descripcion?.raw
                )?.content[0]?.content[0]?.value
              }
            </h3>
            <div className="blockquoteclose"></div>
          </div>
          <div className="m-sup-footer__phrase__container__author">
            <p>
              {
                data?.referenciaContenido[0]?.referenciaPlantillaContenido[
                  data?.referenciaContenido[0]?.referenciaPlantillaContenido
                    ?.length - 1
                ]?.tituloBanner
              }
            </p>
          </div>
          {/* <div className="m-sup-footer__phrase__container__btn">
            <Button
              text={"Ver más"}
              classname={"a-button secondary l-large"}
              type={"button"}
              isDisabled={false}
              strictCss={false}
              gtmMark={`gtmRedDeAmorGruposDeApoyo${normalizeTwoWords("GruposApoyo")}${normalizeTwoWords("Ver más")}`}
              onClickAction={() =>
                navigate("/servicios/grupos-de-apoyo")
              }
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SupportGroupFooter;
